import { memo } from 'react';
import { channelMeta } from './channel';
import type { CommChannel } from './types';

interface ChannelPillProps {
  channel: CommChannel | string;
  size?: 'sm' | 'md';
}

export const ChannelPill = memo(function ChannelPill({ channel, size = 'sm' }: ChannelPillProps) {
  const meta = channelMeta(channel);
  const sizeClass = size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${sizeClass} ${meta.bg} ${meta.text} ${meta.darkBg} ${meta.darkText}`}
    >
      <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d={meta.iconPath} />
      </svg>
      {meta.label}
    </span>
  );
});
